import React from 'react'

import InputMask from 'react-input-mask'
import { Form } from 'rsuite'

/*
  Proxied component
*/

function FormMaskControlProxy ({
  onChange,
  mask,
  size = 'md',
  ...rest
}: Record<string, any>) {
  return (
    <InputMask
      {...rest}
      type="tel"
      className={`rs-input rs-input-${size}`}
      mask={mask}
      onChange={(event: any) => {
        onChange(event.target.value)
      }}
    />
  )
}

/*
  Rsuite integration
*/

export default function FormMaskControl ({ ...props }: any) {
  return <Form.Control accepter={FormMaskControlProxy} {...props} />
}
